import React, {
    useEffect,
    useMemo,
    useState,
} from 'react'

import {
    Spin,
} from 'antd'

import {
    useNavigate,
    useParams,
} from 'react-router-dom'

import fetch from 'auth/FetchInterceptor'

import {
    env,
} from 'configs/EnvironmentConfig'

import {
    OfflineLobbyService,
} from 'offline'

// ======================================================
// API / IMAGENS
// ======================================================

const API_BASE_URL =
    env.API_ENDPOINT_URL

const getImageUrl = (
    value,
) => {
    if (!value) {
        return ''
    }

    if (
        value.startsWith(
            'http://',
        ) ||
        value.startsWith(
            'https://',
        ) ||
        value.startsWith(
            'data:',
        )
    ) {
        return value
    }

    return `${API_BASE_URL}${value}`
}

// ======================================================
// COMPONENTE
// ======================================================

const PublicGameLobby =
    () => {
        const {
            eventSlug,
        } =
            useParams()

        const navigate =
            useNavigate()

        const [
            loading,
            setLoading,
        ] =
            useState(true)

        const [
            data,
            setData,
        ] =
            useState(null)

        const [
            error,
            setError,
        ] =
            useState(null)

        // ======================================================
        // CARREGAR LOBBY
        // ======================================================

        useEffect(
            () => {
                console.log(
                    '[LOBBY DEBUG] useEffect iniciado',
                    {
                        eventSlug,
                        online: navigator.onLine,
                    },
                )

                let mounted =
                    true

                const load =
                    async () => {
                        try {
                            console.log(
                                '[LOBBY DEBUG] iniciando load()',
                            )

                            setLoading(
                                true,
                            )

                            setError(
                                null,
                            )

                            let result =
                                null

                            // ==========================================
                            // 1. TENTAR API
                            // ==========================================

                            try {
                                console.log(
                                    '[LOBBY DEBUG] tentando API:',
                                    `/game-lobby/public/${eventSlug}`,
                                )

                                result =
                                    await fetch({
                                        url:
                                            `/game-lobby/public/${eventSlug}`,

                                        method:
                                            'get',

                                        silentNetworkError:
                                            true,
                                    })

                                console.log(
                                    '[LOBBY DEBUG] resposta API:',
                                    result,
                                )

                                // ======================================
                                // SALVAR LOBBY OFFLINE
                                // ======================================

                                if (
                                    result?.lobby
                                ) {
                                    try {
                                        console.log(
                                            '[LOBBY DEBUG] salvando lobby offline...',
                                        )

                                        await OfflineLobbyService
                                            .saveLobby(
                                                eventSlug,
                                                result,
                                            )

                                        console.log(
                                            '[LOBBY DEBUG] lobby salvo offline com sucesso.',
                                        )

                                        // Confirma imediatamente
                                        // se realmente foi gravado.

                                        const savedLobby =
                                            await OfflineLobbyService
                                                .getLobby(
                                                    eventSlug,
                                                )

                                        console.log(
                                            '[LOBBY DEBUG] conferência após salvar:',
                                            savedLobby,
                                        )
                                    } catch (
                                    cacheError
                                    ) {
                                        console.error(
                                            '[LOBBY DEBUG] ERRO AO SALVAR CACHE:',
                                            cacheError,
                                        )
                                    }
                                } else {
                                    console.warn(
                                        '[LOBBY DEBUG] API respondeu, mas não retornou result.lobby.',
                                        result,
                                    )
                                }
                            } catch (
                            apiError
                            ) {
                                // ======================================
                                // 2. API FALHOU -> TENTAR OFFLINE
                                // ======================================

                                console.warn(
                                    '[LOBBY DEBUG] API FALHOU:',
                                    apiError,
                                )

                                console.log(
                                    '[LOBBY DEBUG] buscando cache para:',
                                    eventSlug,
                                )

                                try {
                                    result =
                                        await OfflineLobbyService
                                            .getLobby(
                                                eventSlug,
                                            )

                                    console.log(
                                        '[LOBBY DEBUG] RESULTADO CACHE:',
                                        result,
                                    )
                                } catch (
                                offlineError
                                ) {
                                    console.error(
                                        '[LOBBY DEBUG] ERRO AO LER CACHE:',
                                        offlineError,
                                    )

                                    result =
                                        null
                                }
                            }

                            // ==========================================
                            // 3. VERIFICAR RESULTADO FINAL
                            // ==========================================

                            console.log(
                                '[LOBBY DEBUG] resultado final:',
                                result,
                            )

                            console.log(
                                '[LOBBY DEBUG] result?.lobby:',
                                result?.lobby,
                            )

                            if (
                                !result?.lobby
                            ) {
                                console.error(
                                    '[LOBBY DEBUG] LOBBY_NOT_AVAILABLE',
                                    {
                                        result,
                                        eventSlug,
                                        online:
                                            navigator.onLine,
                                    },
                                )

                                throw new Error(
                                    'LOBBY_NOT_AVAILABLE',
                                )
                            }

                            // ==========================================
                            // 4. COLOCAR NO REACT
                            // ==========================================

                            if (
                                mounted
                            ) {
                                console.log(
                                    '[LOBBY DEBUG] setData executado.',
                                )

                                setData(
                                    result,
                                )
                            }
                        } catch (
                        err
                        ) {
                            console.error(
                                '[LOBBY DEBUG] ERRO FINAL:',
                                err,
                            )

                            console.log(
                                '[LOBBY DEBUG] eventSlug:',
                                eventSlug,
                            )

                            console.log(
                                '[LOBBY DEBUG] navigator.onLine:',
                                navigator.onLine,
                            )

                            if (
                                mounted
                            ) {
                                setError(
                                    `Página inicial não disponível neste dispositivo. ${err?.message ||
                                    'Erro desconhecido'
                                    }`,
                                )
                            }
                        } finally {
                            if (
                                mounted
                            ) {
                                setLoading(
                                    false,
                                )
                            }
                        }
                    }

                if (
                    eventSlug
                ) {
                    load()
                } else {
                    console.error(
                        '[LOBBY DEBUG] eventSlug não encontrado.',
                    )

                    setLoading(
                        false,
                    )
                }

                return () => {
                    mounted =
                        false
                }
            },
            [
                eventSlug,
            ],
        )

        // ======================================================
        // DADOS
        // ======================================================

        const lobby =
            data?.lobby

        const event =
            data?.event

        const orientation =
            lobby?.orientation ||
            'VERTICAL'

        const isVertical =
            orientation ===
            'VERTICAL'

        const cards =
            useMemo(
                () => {
                    const list =
                        Array.isArray(
                            lobby?.cards,
                        )
                            ? lobby.cards
                            : []

                    return [
                        ...list,
                    ]
                        .filter(
                            (
                                card,
                            ) =>
                                card.isEnabled,
                        )
                        .sort(
                            (
                                a,
                                b,
                            ) =>
                                (a.sortOrder ||
                                    0) -
                                (b.sortOrder ||
                                    0),
                        )
                },
                [
                    lobby,
                ],
            )

        // ======================================================
        // TELA CHEIA
        // ======================================================

        useEffect(
            () => {
                if (
                    !lobby
                ) {
                    return
                }

                if (
                    !lobby.fullscreenEnabled
                ) {
                    return
                }

                const requestFullscreen =
                    async () => {
                        try {
                            if (
                                document.fullscreenElement
                            ) {
                                return
                            }

                            if (
                                document.documentElement
                                    ?.requestFullscreen
                            ) {
                                await document.documentElement
                                    .requestFullscreen()
                            }
                        } catch (
                        error
                        ) {
                            // Navegadores normalmente exigem interação
                            // do usuário antes de liberar fullscreen.
                        }
                    }

                const handleFirstInteraction =
                    () => {
                        requestFullscreen()

                        document.removeEventListener(
                            'click',
                            handleFirstInteraction,
                        )

                        document.removeEventListener(
                            'touchstart',
                            handleFirstInteraction,
                        )
                    }

                document.addEventListener(
                    'click',
                    handleFirstInteraction,
                )

                document.addEventListener(
                    'touchstart',
                    handleFirstInteraction,
                )

                return () => {
                    document.removeEventListener(
                        'click',
                        handleFirstInteraction,
                    )

                    document.removeEventListener(
                        'touchstart',
                        handleFirstInteraction,
                    )
                }
            },
            [
                lobby,
            ],
        )

        // ======================================================
        // ABRIR JOGO
        // ======================================================

        const handlePlay =
            (
                card,
            ) => {
                const game =
                    card?.game

                if (
                    !game?.slug
                ) {
                    return
                }

                navigate(
                    `/play/${game.slug}`,
                )
            }

        // ======================================================
        // LOADING
        // ======================================================

        if (
            loading
        ) {
            return (
                <div
                    style={{
                        width:
                            '100vw',

                        height:
                            '100vh',

                        display:
                            'flex',

                        alignItems:
                            'center',

                        justifyContent:
                            'center',

                        background:
                            '#081A73',
                    }}
                >
                    <Spin
                        size="large"
                    />
                </div>
            )
        }

        // ======================================================
        // ERRO
        // ======================================================

        if (
            error ||
            !lobby
        ) {
            return (
                <div
                    style={{
                        width:
                            '100vw',

                        height:
                            '100vh',

                        display:
                            'flex',

                        flexDirection:
                            'column',

                        alignItems:
                            'center',

                        justifyContent:
                            'center',

                        background:
                            '#081A73',

                        color:
                            '#ffffff',

                        textAlign:
                            'center',

                        padding:
                            40,
                    }}
                >
                    <div
                        style={{
                            fontSize:
                                40,

                            fontWeight:
                                900,
                        }}
                    >
                        Página indisponível
                    </div>

                    <div
                        style={{
                            marginTop:
                                12,

                            fontSize:
                                20,

                            opacity:
                                0.8,
                        }}
                    >
                        {error ||
                            'Página inicial não encontrada.'}
                    </div>
                </div>
            )
        }

        // ======================================================
        // RENDER
        // ======================================================

        return (
            <div
                style={{
                    width:
                        '100vw',

                    minHeight:
                        '100vh',

                    height:
                        '100vh',

                    overflow:
                        'hidden',

                    backgroundColor:
                        lobby.backgroundColor ||
                        '#081A73',

                    backgroundImage:
                        lobby.backgroundUrl
                            ? `url(${getImageUrl(
                                lobby.backgroundUrl,
                            )})`
                            : 'none',

                    backgroundSize:
                        'cover',

                    backgroundPosition:
                        'center',

                    backgroundRepeat:
                        'no-repeat',

                    position:
                        'relative',

                    fontFamily:
                        'Arial, Helvetica, sans-serif',

                    userSelect:
                        'none',
                }}
            >
                {/* ==================================================
            OVERLAY
        ================================================== */}

                <div
                    style={{
                        position:
                            'absolute',

                        inset:
                            0,

                        background:
                            'linear-gradient(180deg, rgba(5,12,70,.08) 0%, rgba(6,8,60,.22) 100%)',

                        pointerEvents:
                            'none',
                    }}
                />

                {/* ==================================================
            CONTEÚDO
        ================================================== */}

                <div
                    style={{
                        position:
                            'relative',

                        zIndex:
                            2,

                        width:
                            '100%',

                        height:
                            '100%',

                        boxSizing:
                            'border-box',

                        display:
                            'flex',

                        flexDirection:
                            'column',

                        alignItems:
                            'center',

                        padding:
                            isVertical
                                ? '5vh 5vw 3vh'
                                : '4vh 5vw 3vh',
                    }}
                >
                    {/* ==================================================
              LOGO
          ================================================== */}

                    {lobby.showLogo &&
                        lobby.logoUrl && (
                            <img
                                src={getImageUrl(
                                    lobby.logoUrl,
                                )}
                                alt={
                                    event?.name ||
                                    'Logo'
                                }
                                draggable={
                                    false
                                }
                                style={{
                                    width:
                                        `${Math.min(
                                            Number(
                                                lobby.logoWidth ||
                                                300,
                                            ),
                                            isVertical
                                                ? 600
                                                : 500,
                                        )}px`,

                                    maxWidth:
                                        isVertical
                                            ? '70vw'
                                            : '28vw',

                                    maxHeight:
                                        isVertical
                                            ? '15vh'
                                            : '13vh',

                                    objectFit:
                                        'contain',

                                    marginBottom:
                                        isVertical
                                            ? '2vh'
                                            : '1.5vh',
                                }}
                            />
                        )}

                    {/* ==================================================
              TÍTULO
          ================================================== */}

                    <div
                        style={{
                            color:
                                '#ffffff',

                            fontSize:
                                isVertical
                                    ? 'clamp(32px, 5vw, 78px)'
                                    : 'clamp(30px, 3.4vw, 70px)',

                            fontWeight:
                                950,

                            lineHeight:
                                1,

                            textAlign:
                                'center',

                            textTransform:
                                'uppercase',

                            textShadow:
                                '0 5px 14px rgba(0,0,0,.35)',

                            letterSpacing:
                                '-1px',
                        }}
                    >
                        {lobby.title ||
                            'ESCOLHA SEU JOGO!'}
                    </div>

                    {/* ==================================================
              SUBTÍTULO
          ================================================== */}

                    {lobby.subtitle && (
                        <div
                            style={{
                                color:
                                    '#ffffff',

                                fontSize:
                                    isVertical
                                        ? 'clamp(18px, 2.4vw, 32px)'
                                        : 'clamp(17px, 1.5vw, 28px)',

                                fontWeight:
                                    600,

                                opacity:
                                    0.95,

                                textAlign:
                                    'center',

                                marginTop:
                                    isVertical
                                        ? '1.2vh'
                                        : '1vh',

                                textShadow:
                                    '0 3px 8px rgba(0,0,0,.3)',
                            }}
                        >
                            {
                                lobby.subtitle
                            }
                        </div>
                    )}

                    {/* ==================================================
              CARDS
          ================================================== */}

                    <div
                        style={{
                            flex:
                                1,

                            width:
                                '100%',

                            display:
                                'flex',

                            flexDirection:
                                isVertical
                                    ? 'column'
                                    : 'row',

                            alignItems:
                                'center',

                            justifyContent:
                                'center',

                            gap:
                                `${Math.max(
                                    14,
                                    Number(
                                        lobby.cardGap ||
                                        32,
                                    ),
                                )}px`,

                            minHeight:
                                0,

                            padding:
                                isVertical
                                    ? '3vh 0'
                                    : '2.5vh 0',
                        }}
                    >
                        {cards.length ===
                            0 ? (
                            <div
                                style={{
                                    color:
                                        '#ffffff',

                                    background:
                                        'rgba(255,255,255,.12)',

                                    border:
                                        '2px dashed rgba(255,255,255,.35)',

                                    padding:
                                        '30px 50px',

                                    borderRadius:
                                        24,

                                    fontSize:
                                        24,

                                    fontWeight:
                                        700,
                                }}
                            >
                                Nenhum jogo disponível.
                            </div>
                        ) : (
                            cards.map(
                                (
                                    card,
                                ) => (
                                    <button
                                        key={
                                            card.id
                                        }
                                        type="button"
                                        onClick={() =>
                                            handlePlay(
                                                card,
                                            )
                                        }
                                        disabled={
                                            !card.game
                                        }
                                        style={{
                                            border:
                                                'none',

                                            outline:
                                                'none',

                                            appearance:
                                                'none',

                                            cursor:
                                                card.game
                                                    ? 'pointer'
                                                    : 'default',

                                            width:
                                                isVertical
                                                    ? 'min(88vw, 900px)'
                                                    : `${Math.min(
                                                        30,
                                                        90 /
                                                        Math.max(
                                                            cards.length,
                                                            1,
                                                        ),
                                                    )}%`,

                                            height:
                                                isVertical
                                                    ? `min(${54 /
                                                    Math.max(
                                                        cards.length,
                                                        1,
                                                    )
                                                    }vh, 430px)`
                                                    : 'min(55vh, 560px)',

                                            minHeight:
                                                isVertical
                                                    ? 190
                                                    : 300,

                                            minWidth:
                                                isVertical
                                                    ? 0
                                                    : 260,

                                            maxWidth:
                                                isVertical
                                                    ? 900
                                                    : 600,

                                            position:
                                                'relative',

                                            overflow:
                                                'hidden',

                                            borderRadius:
                                                `${Math.max(
                                                    8,
                                                    Number(
                                                        lobby.cardBorderRadius ||
                                                        40,
                                                    ),
                                                )}px`,

                                            backgroundColor:
                                                card.backgroundColor ||
                                                '#1677ff',

                                            backgroundImage:
                                                card.imageUrl
                                                    ? `url(${getImageUrl(
                                                        card.imageUrl,
                                                    )})`
                                                    : 'none',

                                            backgroundSize:
                                                'cover',

                                            backgroundPosition:
                                                'center',

                                            backgroundRepeat:
                                                'no-repeat',

                                            padding:
                                                0,

                                            boxShadow:
                                                lobby.cardShowShadow
                                                    ? '0 16px 38px rgba(0,0,0,.30)'
                                                    : 'none',

                                            transition:
                                                'transform .15s ease, box-shadow .15s ease',

                                            color:
                                                card.textColor ||
                                                '#ffffff',
                                        }}
                                    >
                                        {/* ======================================
                        SOMBRA DO CARD
                    ====================================== */}

                                        <div
                                            style={{
                                                position:
                                                    'absolute',

                                                inset:
                                                    0,

                                                background:
                                                    card.imageUrl
                                                        ? 'linear-gradient(180deg, rgba(0,0,0,0) 15%, rgba(0,0,0,.05) 45%, rgba(0,0,0,.82) 100%)'
                                                        : 'linear-gradient(180deg, rgba(255,255,255,.05), rgba(0,0,0,.10))',

                                                pointerEvents:
                                                    'none',
                                            }}
                                        />

                                        {/* ======================================
                        CONTEÚDO DO CARD
                    ====================================== */}

                                        <div
                                            style={{
                                                position:
                                                    'absolute',

                                                left:
                                                    0,

                                                right:
                                                    0,

                                                bottom:
                                                    0,

                                                zIndex:
                                                    2,

                                                display:
                                                    'flex',

                                                alignItems:
                                                    'center',

                                                justifyContent:
                                                    'space-between',

                                                gap:
                                                    20,

                                                padding:
                                                    isVertical
                                                        ? '24px 34px'
                                                        : '28px 28px',

                                                textAlign:
                                                    'left',
                                            }}
                                        >
                                            <div
                                                style={{
                                                    flex:
                                                        1,

                                                    minWidth:
                                                        0,
                                                }}
                                            >
                                                <div
                                                    style={{
                                                        color:
                                                            card.textColor ||
                                                            '#ffffff',

                                                        fontSize:
                                                            isVertical
                                                                ? 'clamp(24px, 4vw, 50px)'
                                                                : 'clamp(22px, 2vw, 38px)',

                                                        fontWeight:
                                                            950,

                                                        lineHeight:
                                                            1,

                                                        textTransform:
                                                            'uppercase',

                                                        textShadow:
                                                            card.imageUrl
                                                                ? '0 4px 10px rgba(0,0,0,.75)'
                                                                : 'none',
                                                    }}
                                                >
                                                    {
                                                        card.title
                                                    }
                                                </div>

                                                {card.description && (
                                                    <div
                                                        style={{
                                                            color:
                                                                card.textColor ||
                                                                '#ffffff',

                                                            fontSize:
                                                                isVertical
                                                                    ? 'clamp(15px, 2vw, 25px)'
                                                                    : 'clamp(14px, 1.1vw, 21px)',

                                                            fontWeight:
                                                                600,

                                                            lineHeight:
                                                                1.2,

                                                            marginTop:
                                                                8,

                                                            opacity:
                                                                0.95,

                                                            textShadow:
                                                                card.imageUrl
                                                                    ? '0 3px 8px rgba(0,0,0,.75)'
                                                                    : 'none',
                                                        }}
                                                    >
                                                        {
                                                            card.description
                                                        }
                                                    </div>
                                                )}
                                            </div>

                                            {/* ==================================
                          BOTÃO
                      ================================== */}

                                            <div
                                                style={{
                                                    flexShrink:
                                                        0,

                                                    display:
                                                        'flex',

                                                    alignItems:
                                                        'center',

                                                    justifyContent:
                                                        'center',

                                                    minWidth:
                                                        isVertical
                                                            ? 110
                                                            : 90,

                                                    height:
                                                        isVertical
                                                            ? 58
                                                            : 50,

                                                    padding:
                                                        '0 20px',

                                                    background:
                                                        '#ffffff',

                                                    color:
                                                        card.backgroundColor ||
                                                        '#1677ff',

                                                    borderRadius:
                                                        999,

                                                    fontSize:
                                                        isVertical
                                                            ? 17
                                                            : 14,

                                                    fontWeight:
                                                        950,

                                                    boxShadow:
                                                        '0 6px 18px rgba(0,0,0,.25)',
                                                }}
                                            >
                                                {card.buttonText ||
                                                    'JOGAR'}
                                            </div>
                                        </div>
                                    </button>
                                ),
                            )
                        )}
                    </div>

                    {/* ==================================================
              RODAPÉ
          ================================================== */}

                    {lobby.footerText && (
                        <div
                            style={{
                                color:
                                    '#ffffff',

                                fontSize:
                                    isVertical
                                        ? 'clamp(16px, 2vw, 25px)'
                                        : 'clamp(15px, 1.3vw, 22px)',

                                fontWeight:
                                    600,

                                opacity:
                                    0.9,

                                textAlign:
                                    'center',

                                paddingBottom:
                                    '1vh',

                                textShadow:
                                    '0 3px 8px rgba(0,0,0,.4)',
                            }}
                        >
                            {
                                lobby.footerText
                            }
                        </div>
                    )}
                </div>
            </div>
        )
    }

export default PublicGameLobby